import React from 'react';
import { Grid, Card, CardContent, Box, Typography } from '@mui/material';
import {
  TrendingUp as TrendingUpIcon,
  Schedule as ScheduleIcon,
  Timeline as TimelineIcon,
  AccountBalance as AccountBalanceIcon
} from '@mui/icons-material';
import { formatCurrency } from '../../utils/liquidacionHelpers';

/**
 * Componente de cards de resumen de liquidaciones
 * @param {Object} resumen - Objeto con estadísticas de liquidación
 */
const ResumenCards = ({ resumen = {} }) => {
  const { servicios_pendientes = {}, estadisticas_pagos = {} } = resumen;

  return (
    <Grid container spacing={3} sx={{ mb: 4 }}>
      {/* Card: Servicios Pendientes */}
      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            background: 'linear-gradient(135deg, #4CAF50 0%, #45A049 100%)',
            color: 'white'
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TrendingUpIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h6">Servicios Pendientes</Typography>
                <Typography variant="h4">
                  {servicios_pendientes.servicios_sin_liquidar || 0}
                </Typography>
                <Typography variant="body2">
                  {formatCurrency(servicios_pendientes.comisiones_pendientes)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {/* Card: Pagos Pendientes */}
      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            background: 'linear-gradient(135deg, #FF9800 0%, #F57C00 100%)',
            color: 'white'
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <ScheduleIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h6">Pagos Pendientes</Typography>
                <Typography variant="h4">
                  {estadisticas_pagos.pagos_pendientes || 0}
                </Typography>
                <Typography variant="body2">
                  {formatCurrency(estadisticas_pagos.monto_pendiente)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {/* Card: En Proceso */}
      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            background: 'linear-gradient(135deg, #2196F3 0%, #1976D2 100%)',
            color: 'white'
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <TimelineIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h6">En Proceso</Typography>
                <Typography variant="h4">
                  {estadisticas_pagos.pagos_en_proceso || 0}
                </Typography>
                <Typography variant="body2">
                  {formatCurrency(estadisticas_pagos.monto_en_proceso)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>

      {/* Card: Pagado Este Mes */}
      <Grid item xs={12} sm={6} md={3}>
        <Card
          sx={{
            background: 'linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%)',
            color: 'white'
          }}
        >
          <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <AccountBalanceIcon sx={{ fontSize: 40 }} />
              <Box>
                <Typography variant="h6">Pagado Este Mes</Typography>
                <Typography variant="h4">
                  {estadisticas_pagos.pagos_mes_actual || 0}
                </Typography>
                <Typography variant="body2">
                  {formatCurrency(estadisticas_pagos.monto_pagado_mes)}
                </Typography>
              </Box>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default ResumenCards;
